/**
 * Configuración de proveedores OAuth
 * Agrega nuevos proveedores aquí
 */

export const OAUTH_PROVIDERS = {
  ikos: {
    name: 'IKOS',
    clientId: 'bayer-nematool-test', // Usando credenciales de TEST
    authorizeUrl: 'https://api.ikostech.es/it/auth/authorize',
    tokenUrl: 'https://api.ikostech.es/it/auth/token/access',
    apiBaseUrl: 'https://api.ikostech.es/it',
    scopes: ['email', 'devices'],
    usesPKCE: true,
    redirectUri: 'https://apptest.nematool.com/oauth/provider/ikos', // URI registrada en IKOS
    customParams: {
      ikos_jwt: true // Parámetro específico de IKOS
    },
    endpoints: {
      devices: '/export/nodes',
      userInfo: '/user/info'
    }
  },
  
};

/**
 * Obtener configuración de un proveedor
 */
export const getProviderConfig = (providerId) => {
  const config = OAUTH_PROVIDERS[providerId];
  if (!config) {
    throw new Error(`Proveedor no soportado: ${providerId}`);
  }
  return config;
};

/**
 * Obtener lista de proveedores disponibles
 */
export const getAvailableProviders = () => {
  return Object.keys(OAUTH_PROVIDERS).map(id => ({
    id,
    name: OAUTH_PROVIDERS[id].name
  }));
};

/**
 * Validar si un proveedor es soportado
 */
export const isProviderSupported = (providerId) => {
  return providerId && OAUTH_PROVIDERS.hasOwnProperty(providerId);
};
